<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-success swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">

  <div *ngIf="state == 'loading'">
    <div class="swal2-header">
      <mat-spinner [diameter]="80"></mat-spinner>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="start" i18n="@@StartingCharging-ProcessHeader">Der Ladevorgang wird gestartet.</h2>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="!start" i18n="@@StoppingCharging-ProcessHeader">Der Ladevorgang wird gestoppt.</h2>
    </div>
  </div>

  <div *ngIf="state == 'success'">
    <div class="swal2-header">
      <div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
        <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
        <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
        <div class="swal2-success-ring"></div>
        <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
        <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="start" i18n="@@Charging-ProcessWasStartedHeader">Ladevorgang gestartet.</h2>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="!start" i18n="@@Charging-ProcessWasStopped">Ladevorgang gestoppt.</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;" *ngIf="start && !chargingWillBeAssignedToUser" i18n="@@ManualStartOfCharging-ProcessWarning">
        Der Ladevorgang wurde manuell gestartet. Sie können den Ladevorgang jederzeit unterbrechen.<br />
        <b>Hinweis:</b> Der Ladevorgang wird keinem Benutzer zugeordnet und kann nicht abgerechnet werden!
      </div>
    </div>
  </div>


  <div *ngIf="state == 'failure'">
    <div class="swal2-header">
      <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;">
        <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="start" i18n="@@Charging-ProcessStartError">Ladevorgang konnte nicht gestartet werden.</h2>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="!start" i18n="@@Charging-ProcessStopError">Ladevorgang konnte nicht gestoppt werden.</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;" *ngIf="start" i18n="@@PleaseCheckTheFollowingPointsAndRetry">
        Bitte prüfen Sie die folgenden Punkte und führen Sie anschließend erneut diese Funktion aus:
        <br /> - Ist das Auto bereits mit der Ladestation verbunden?
        <br /> - Ist das Auto bereits vollständig geladen?
        <br /> - Ist die Ladestation erreichbar (Status: online)?
      </div>
      <div id="swal2-content" class="swal2-html-container" style="display: block;" *ngIf="!start" i18n="@@Charging-ProcessStopError">
        
      </div>
    </div>
  </div>

  <div *ngIf="state == 'stationnotauthorized'">
    <div class="swal2-header">
      <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;">
        <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@Charging-ProcessStartError">Ladevorgang konnte nicht gestartet werden.</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@StationNotAuthorizedQrPublicHint">
        Sie sind für diese Station nicht freigeschaltet. Für Laden per QR-Code bitte abmelden oder den öffentlichen Start nutzen.
      </div>
    </div>
  </div>

  <div *ngIf="state == 'insufficientrights'">
    <div class="swal2-header">
      <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;">
        <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="start" i18n="@@Charging-ProcessStartError">Ladevorgang konnte nicht gestartet werden.</h2>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" *ngIf="!start" i18n="@@Charging-ProcessStopError">Ladevorgang konnte nicht gestoppt werden.</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;" *ngIf="start" i18n="@@PleaseCheckTheFollowingPointsAndRetry">
        Wie hast du das geschafft ?
      </div>
      <div id="swal2-content" class="swal2-html-container" style="display: block;" *ngIf="!start" i18n="@@Charging-ProcessStopError">
        Der Ladevorgang konnte nicht gestoppt werden, da dieser von einem anderen Nutzer gestartet wurde.
      </div>
    </div>
  </div>

  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button type="button" id="ok" class="btn btn-danger" aria-label="" style="display: inline-block;" (click)="onConfirmClick()" i18n="@@OkButton">OK</button>
  </div>
</div>
